import Vue from 'vue'
import Router from 'vue-router'

import '@/assets/css/header.css'
import '@/assets/css/reset.css'
import Shop from '@/views/shop.vue'
import Item from '@/views/item.vue'
import Cart from '@/views/cart.vue'
import Checkout from '@/views/checkout.vue'
import Payment from '@/views/payment.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      name: 'Shop',
      path: '/',
      component: Shop
    },
    {
      name: 'cityInfoPage',
      path: '/cityInfoPage',
      component: () => import('@/views/cityInfoPage.vue'),
    },
    {
      name: 'Item',
      path: '/item',
      component: Item,
    }, {
      name: 'Cart',
      path: '/cart',
      component: Cart,
    },
    {
      name: 'Checkout',
      path: '/checkout',
      component: Checkout,
    },
    {
      name: 'Payment',
      path: '/payment',
      component: Payment,
    },
    {
      name: 'StoreEnter',
      path: '/storeEnter',
      component: () => import('@/views/storeEnter.vue'),
    }
    ,
    {
      name: 'GoodsList',
      path: '/goodsList',
      component: () => import('@/views/goodsList.vue'),
    }
    ,
    {
      name: 'CityInfo',
      path: '/cityInfo',
      component: () => import('@/views/cityInfo.vue'),
    }
    ,
    {
      name: 'PublishInfo',
      path: '/publishInfo',
      component: () => import('@/views/publishInfo.vue'),
    }, {
      name: 'ysbh',
      path: '/ysbh',
      component: () => import('@/views/ysbh.vue'),
    }, {
      name: 'yhxy',
      path: '/yhxy',
      component: () => import('@/views/yhxy.vue'),
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js